const upsellSelectors = {
    modal: document.getElementById('cartUpsellModal'),
    container: document.querySelector('#cartUpsellModal [data_upsell_product]')
  };
  
  class cartUpsellJS {
    constructor() {
    
    document.querySelectorAll("#ModalClose-cartUpsellModal").forEach(ele => {
      ele.addEventListener('click',(event)=>{
          document.querySelector("#ModalClose-cartUpsellModal").click();  
          document.querySelectorAll("[data-add-cart]").forEach(ele => {
            if(ele.classList.contains("loading")) ele.classList.remove("loading");
            if(ele.hasAttribute("disabled")) ele.removeAttribute("disabled");
          })
      });
    });

    if(document.querySelector("#rc_radio_options") != null){
      document.querySelector("#rc_radio_options").addEventListener('change',(event)=>{
        event.stopImmediatePropagation();
        this._checksubscription();
      });
    }
    if(document.querySelector("#rc_radio_options") != null){
      this._checksubscription();
    }
      
    }
    _checksubscription(){
      if (document.querySelector("#rc_purchase_type_autodeliver") != null) {
        if( document.querySelector("#rc_purchase_type_autodeliver").checked == true){
          document.querySelector("#rc_shipping_interval_frequency").setAttribute("name", 'properties[shipping_interval_frequency]');
          document.querySelector("#rc_shipping_interval_unit_type").setAttribute("name", 'properties[shipping_interval_unit_type]');
          document.querySelector("#rc_subscription_id").setAttribute("name", 'properties[subscription_id]');
        }
        else{
          document.querySelector("#rc_shipping_interval_frequency").removeAttribute("name", 'properties[shipping_interval_frequency]');
          document.querySelector("#rc_shipping_interval_unit_type").removeAttribute("name", 'properties[shipping_interval_unit_type]');
          document.querySelector("#rc_subscription_id").removeAttribute("name", 'properties[subscription_id]');
        }
      }
    }
  
    hideUpsellProduct(result){
      document.querySelectorAll("[data_upsell-item]").forEach(function(i,v){
        i.classList.remove("d-none");
      });
      setTimeout(() => {
        result.items.forEach(function(y,z){
          document.querySelectorAll("[data_upsell-item='" + y.handle + "']").forEach(function(i) {
            i.classList.add("d-none");
          });
        });
      }, 1000);
     
    }
  
    upsellProduct(result) { 
      this.hideUpsellProduct(result);    
      let html = '';
      let temp_html="";
      result.items.forEach((i, v)=>{
        let price = 0;
        let title;
        if (i.properties['type'] == 'gift-box') {
          title = i.product_title;  
        } else if (i.product_type == "simple" || i.properties['productType'] == "sub_product") {
          title = i.product_title;
        } else if (i.properties['product-title'] != undefined || i.properties['product-title'] != null) {
          title = i.properties['product-title'];
        } else {
          title = i.product_title;
        }
       
        price = Shopify.formatMoney(i.price, window.globalVariables.money_format);
        temp_html = `<div class="col-12 col-md-6 p-2">
          <div class="border p-3 h-100 border-secondary d-flex align-items-center cart-item">
                <a class="my-0 text-danger close-cart-btn" data-variantid="${i.variant_id}" data-randomnumber="${i.properties.randomNumber}" href="javascript:void(0)" title="Remove" name="Remove" aria-label="Remove" data-toggle="tooltip" data-upsellRemove data-index="${v}" data-placement="left">
                    <i class="icon-close"></i>
              </a>
          <div class="d-flex align-items-center w-100">
            <div class="cart-img me-3">
                <img class="img-fluid item-img" style="min-width: 87px;width:87px;" src="${i.image}" alt="${i.title}" loading="lazy" width="75" height="75">
            </div>
            <div class="cart-item-text w-100">
              <a href="${i.url}" class="card-title h6 mb-0 me-2 text-capitalize">${title}</a>
              <ul class="list-unstyled"></ul> 
              <p class="product-option"></p>
              <div class="d-flex align-items-center justify-content-between">
                  <div class="cart-total-price mt-2">${price}</div>
                  <div class="quantity-wrapper mt-2" data-qty-container="">
                    <div class="input-group input-group-sm border">
                        <div class="input-group-prepend">
                          <a href="javascript:void(0)" id="qty_drc_${i.variant_id}" class="btn-decrease input-group-text bg-white border-0 p-2 d-flex h-100 align-items-center" rel="nofollow" data-upsellQty data-index="${v}" aria-label="Decrease ${i.product_title}" title="Decrease quantity for ${i.product_title}" data-for="decrease" data-qty-btn="">
                            <span class="btn-decrease font-size-xs" id="qty_minus_${i.variant_id}"><i class="icon-minus"></i></span>
                            <span class="visually-hidden">Increase quantity for ${i.product_title}</span>
                          </a>
                        </div>
                        <input type="text" data-upsell-quantity name="quantity" aria-label="Quantity for ${i.product_title}" value="${i.quantity}" step="1" min="1" inputmode="numeric" data-qty-input="" class="text-center border-0 p-2 quantity form-control fw-bold text-secondary border-secondary ps-3 h-100" readonly="">
                        <div class="input-group-append">
                          <a href="javascript:void(0)" id="qty_inc_${i.variant_id}" class="btn-increase input-group-text bg-white border-0 p-2 d-flex h-100 align-items-center" rel="nofollow" data-upsellQty data-index="${v}" rel="nofollow" aria-label="Increase quantity for ${i.product_title}" title="Increase quantity for ${i.product_title}" data-for="increase" data-qty-btn="">
                            <span class="btn-increase font-size-xs" id="qty_plus_${i.variant_id}"><i class="icon-plus"></i></span>
                            <span class="visually-hidden">Decrease quantity for ${i.product_title}</span>
                          </a>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>`;
        html = html + temp_html;
        setTimeout(() => {
          if (i.properties['shipping_interval_unit_type']) {
            document.querySelector(`#qty_plus_${i.variant_id}`).classList.add('d-none');
            document.querySelector(`#qty_minus_${i.variant_id}`).classList.add('d-none');
            document.querySelector(`#qty_drc_${i.variant_id}`).style = 'pointer-events:none';
            document.querySelector(`#qty_inc_${i.variant_id}`).style = 'pointer-events:none';
          }
        }, 1000);
      });
      if(upsellSelectors.container){
        upsellSelectors.container.innerHTML = `<div class="row m-n2">${html}</div>`; 
        upsellSelectors.modal.querySelector('.modal').classList.add('open');
        siteOverlay.prototype.showOverlay();
        this.bindEvents();
      }
    }
    
    updateQuantity(variantId, quantitySymbol) {
      let currentTarget = event.currentTarget;
      let quantity = event.currentTarget.parentNode.querySelector("[data-upsell-quantity]").value;
      quantity = parseInt(quantity);
      if(quantitySymbol == "plus" ){
        quantity = quantity + 1;
        event.currentTarget.parentNode.querySelector("[data-upsell-quantity]").value =quantity;
        updateUpsell(variantId,quantity);
  
      }else if(quantitySymbol=="minus" && quantity != 1){
        quantity = quantity - 1;
        event.currentTarget.parentNode.querySelector("[data-upsell-quantity]").value =quantity;
        updateUpsell(variantId,quantity);
      }
    }
    
    bindEvents(){
      let qtyBtns = document.querySelectorAll('[data-upsellQty]');
      let removeBtns = document.querySelectorAll('[data-upsellRemove]');
      let ajaxCartEle = document.querySelector('ajax-cart');
      
      qtyBtns.forEach((Btn)=> {
        Btn.addEventListener('click', (event)=>{
          let currentTarget = event.currentTarget;
          let line = parseInt(currentTarget.dataset.index) + 1;
          let qtyContainer = currentTarget.closest('[data-qty-container]');
          let qtyInput = qtyContainer.querySelector('[name="quantity"]');
          let qty = parseInt(qtyInput.value);
          
          if(currentTarget.classList.contains('btn-increase')){
            qty = qty + 1;
          }else if(qty > 1){
              qty = qty - 1;
          }
          
          ajaxCartEle.updateItemQty(line, qty);
        });
      });
  
      removeBtns.forEach((Btn)=> {
        Btn.addEventListener('click', (event)=>{
          let currentTarget = event.currentTarget;
          let line = parseInt(currentTarget.dataset.index) + 1;
         // ajaxCartEle.updateItemQty(line, 0);
          ajaxCartEle.removeItem(event)
        });
      });
    }
  }
  
  window.onload = () => {
      typeof cartUpsellJS !== 'undefined' && new cartUpsellJS();
  }
